import { merge } from 'lodash';

import { getProjectBrief, updateProjectBriefField } from '@/api/workflow';

const BRIEF_DEFAULT_FIELDS = {
  topic: {
    description: '',
    supportingFiles: []
  },
  objectives: {
    primaryObjective: {
      type: '',
      value: ''
    },
    secondaryObjective: {
      type: '',
      value: ''
    },
    supportingFiles: []
  },
  audiences: [],
  scope: {
    deliverables: '',
    languagesNeeded: '',
    supportingFiles: []
  },
  additionalSections: [],
  supportingFiles: []
};

export default {
  namespaced: true,
  state: () => ({
    brief: {
      loading: false,
      error: null,
      value: null,
      projectId: null
    }
  }),
  mutations: {
    fetchBriefPending(state) {
      state.brief.loading = true;
      state.brief.error = null;
      state.brief.value = null;
      state.brief.projectId = null;
    },
    fetchBriefSuccess(state, { brief, projectId }) {
      state.brief.loading = false;
      state.brief.error = null;
      state.brief.value = merge({}, BRIEF_DEFAULT_FIELDS, brief);
      state.brief.projectId = projectId;
    },
    fetchBriefFailure(state, error) {
      state.brief.loading = false;
      state.brief.error = error;
    },
    setBriefError(state, error) {
      state.brief.error = error;
    },
    setBriefField(state, { field, value }) {
      state.brief.value[field] = value;
    }
  },
  actions: {
    async fetchCurrentProjectBrief({ commit, state, rootState }) {
      if (state.brief.projectId === rootState.workflow.currentProjectId) {
        return;
      }
      commit('fetchBriefPending');
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId
        };
        const brief = await getProjectBrief(payload);
        commit('fetchBriefSuccess', {
          brief,
          projectId: payload.projectId
        });
        return brief;
      } catch (err) {
        console.error('Server error when getting brief', err);
        commit('fetchBriefFailure', 'Error when getting brief');
      }
    },
    async fetchCurrentProjectBriefId({ commit, state, rootState }, id) {
      commit('fetchBriefPending');
      try {
        const payload = {
          projectId: id
        };
        const brief = await getProjectBrief(payload);
        commit('fetchBriefSuccess', {
          brief,
          projectId: payload.projectId
        });
        return brief;
      } catch (err) {
        console.error('Server error when getting brief', err);
        commit('fetchBriefFailure', 'Error when getting brief');
      }
    },
    async fetchCurrentProjectBriefPublic({ commit, state, rootState }, id) {
      commit('fetchBriefPending');
      try {
        const payload = {
          projectId: id
        };
        const brief = await getProjectBrief(payload);
        commit('fetchBriefSuccess', {
          brief,
          projectId: payload.projectId
        });
        return brief;
      } catch (err) {
        console.error('Server error when getting brief', err);
        commit('fetchBriefFailure', 'Error when getting brief');
      }
    },
    async refreshCurrentProjectBrief({ commit, rootState }, brief) {
      commit('fetchBriefSuccess', {
        brief,
        projectId: rootState.workflow.currentProjectId
      });
    },
    async updateCurrentProjectBriefValidated({ commit, state, rootState }, { value }) {
      const previousValue = state.brief.value.validated;
      commit('setBriefField', {
        field: 'validated',
        value
      });
      try {
        const payload = {
          projectId: rootState.workflow.currentProjectId,
          field: 'validated',
          value
        };
        await updateProjectBriefField(payload);
      } catch (err) {
        console.error('Server error when updating validation of project brief', err);
        commit('setBriefField', {
          field: 'validated',
          value: previousValue
        });
        commit('setBriefError', 'Error when updating project brief');
      }
    }
  }
};
